export const readingSubjects = ["phonics", "alphabet", "phrases"] as const
export const storyLevels = ["elementary", "middle", "high"] as const

export type ReadingSubjects = typeof readingSubjects[number]
export type StoryLevels = typeof storyLevels[number]
